import React from 'react';
import { CloudUploadIcon } from '../../../../assets/icons/CloudUploadIcon';
import { Typography } from '../../../widgets/Typography';
import { CloseIcon } from '../../../../assets/icons/CloseIcon';

type Props = {
  setSelectedFile: React.Dispatch<React.SetStateAction<File | null>>;
  selectedFile: File | null;
};

export default function UploadCSVCard({
  setSelectedFile,
  selectedFile,
}: Props) {
  const fileInputRef = React.useRef<HTMLInputElement>(null);
  const [isDragging, setIsDragging] = React.useState(false);

  const hasSelectedFile = Boolean(selectedFile);

  return (
    <div className="flex w-2xl flex-col items-start gap-4 rounded-lg border border-taupe-400 bg-white p-6 shadow-md">
      <div className="flex flex-col items-start gap-1">
        <Typography variant="body-lg" weight="semibold">
          Upload CSV
        </Typography>
        <Typography variant="body-sm" className="text-grey-600 text-pretty">
          After filling out the template, upload your CSV file here to start the
          syncing process. We will validate the data and guide you through the
          next steps.
        </Typography>
        <input
          type="file"
          accept=".csv"
          ref={fileInputRef}
          className="hidden"
          onChange={(e) => {
            const file = e.target.files?.[0];
            if (file) {
              setSelectedFile(file);
            }
          }}
        />
        <button
          className={`border-taupe-550 relative mt-6 flex w-full cursor-pointer flex-col items-center justify-center rounded-xl border px-4 py-8 ${isDragging ? 'bg-taupe-200' : 'bg-taupe-100'}`}
          onClick={() => {
            fileInputRef.current?.click();
          }}
          onDragOver={(e) => {
            e.preventDefault();
            setIsDragging(true);
          }}
          onDragLeave={() => {
            setIsDragging(false);
          }}
          onDrop={(e) => {
            e.preventDefault();
            setIsDragging(false);
            const file = e.dataTransfer.files?.[0];
            if (file) {
              setSelectedFile(file);
            }
          }}
        >
          {hasSelectedFile && (
            <button
              className="absolute top-0 right-0 cursor-pointer p-2"
              onClick={(e) => {
                e.stopPropagation();
                setSelectedFile(null);
                if (fileInputRef.current) {
                  fileInputRef.current.value = '';
                }
              }}
            >
              <CloseIcon className="size-5 stroke-neutral-600" />
            </button>
          )}
          <CloudUploadIcon className="size-8 stroke-taupe-800" />
          <Typography
            variant="body-sm"
            weight="medium"
            className="mt-2 text-taupe-800"
          >
            {hasSelectedFile
              ? selectedFile?.name
              : 'Click here to browse and upload your CSV file or drag and drop it here.'}
          </Typography>
        </button>
      </div>
    </div>
  );
}
